// Pages produit « bz- » : galerie, compositeur de pack, page goût, ajout au panier relié au tiroir d'Horizon.

const money = (cents, format) => {
  const value = (cents / 100).toFixed(2).replace('.', ',');
  return (format || '{{amount_with_comma_separator}} €').replace(/\{\{\s*[a-z_]+\s*\}\}/, value);
};

/* ---------- Ajout au panier (tiroir Horizon, sinon page panier) ---------- */
async function addToCart(items, source) {
  const root = window.Theme?.routes?.root || '/';
  const addUrl = window.Theme?.routes?.cart_add_url || `${root}cart/add`;
  const cartUrl = window.Theme?.routes?.cart_url || `${root}cart`;
  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);

  let events = null;
  try { events = await import('@shopify/events'); } catch (e) { events = null; }

  let deferred = null;
  if (events?.CartLinesUpdateEvent) {
    deferred = events.CartLinesUpdateEvent.createPromise();
    source.dispatchEvent(new events.CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
      promise: deferred.promise,
    }));
  }

  const res = await fetch(`${addUrl}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items, sections: sectionIds.join(',') }),
  });
  const data = await res.json();
  const cart = await fetch(`${cartUrl}.js`).then((r) => r.json()).catch(() => null);

  if (data.status) {
    deferred?.resolve({ cart: cart && events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, source: 'bz-pack' } });
    throw new Error(data.description || data.message || "L'ajout au panier a échoué.");
  }

  document.querySelectorAll('[data-bz-cart-count]').forEach((el) => { el.textContent = cart?.item_count > 0 ? cart.item_count : ''; });

  if (deferred && cart) {
    deferred.resolve({
      cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: data.items, source: 'bz-pack', sourceId: source.id, itemCount: items.reduce((n, i) => n + i.quantity, 0), sections: data.sections },
    });
    const drawer = document.getElementById('cart-drawer');
    setTimeout(() => { if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) drawer.open(); }, 250);
    if (!drawer) window.location.href = cartUrl;
  } else {
    window.location.href = cartUrl;
  }
}

/* ---------- Galerie ---------- */
function initGallery(root) {
  const track = root.querySelector('[data-bz-gallery-track]');
  if (!track) return;
  const slides = [...track.children];
  const dots = root.querySelector('[data-bz-gallery-dots]');
  const thumbs = [...root.querySelectorAll('[data-bz-thumb]')];
  const go = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  if (dots) slides.forEach((_, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.setAttribute('aria-label', `Image ${i + 1}`);
    b.addEventListener('click', () => go(i));
    dots.appendChild(b);
  });
  const sync = () => {
    const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    dots && [...dots.children].forEach((d, k) => d.classList.toggle('is-on', k === i));
    thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
  };
  thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
  root.querySelector('[data-bz-gallery-prev]')?.addEventListener('click', () => go(Math.max(0, Math.round(track.scrollLeft / track.clientWidth) - 1)));
  root.querySelector('[data-bz-gallery-next]')?.addEventListener('click', () => go(Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth) + 1)));
  track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
  sync();
}

/* ---------- Compte à rebours d'expédition ---------- */
function initCountdown(el) {
  const hour = Number(el.dataset.hour || 12);
  const out = el.querySelector('strong');
  const tick = () => {
    const now = new Date();
    const cut = new Date(now); cut.setHours(hour, 0, 0, 0);
    if (now >= cut || now.getDay() === 0 || now.getDay() === 6) {
      do { cut.setDate(cut.getDate() + 1); } while (cut.getDay() === 0 || cut.getDay() === 6);
    }
    const s = Math.max(0, Math.floor((cut - now) / 1000));
    const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    out.textContent = `${String(h).padStart(2, '0')}h${String(m).padStart(2, '0')}min${String(sec).padStart(2, '0')}s`;
  };
  tick(); setInterval(tick, 1000);
}

/* ---------- Date de livraison estimée : heure limite, puis N jours ouvrés (sans samedi ni dimanche) ---------- */
function initDelivery(el) {
  const cutoff = Number(el.dataset.cutoff || 16);
  const days = Number(el.dataset.days || 2);
  const out = el.querySelector('strong');
  const weekend = (d) => d.getDay() === 0 || d.getDay() === 6;
  const d = new Date();
  if (d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
  while (weekend(d)) d.setDate(d.getDate() + 1);
  for (let left = days; left > 0;) {
    d.setDate(d.getDate() + 1);
    if (!weekend(d)) left -= 1;
  }
  out.textContent = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
}

/* ---------- Compositeur de pack ----------
   Les prix suivent les remises automatiques de la boutique : le palier appliqué dépend du nombre total
   de paquets dans le pack (le plus haut palier atteint), sans cumul. Achat unique : remise en %.
   Abonnement : remise en % ou montant fixe en euros sur la commande. */
function initPack(root) {
  const fmt = root.dataset.moneyFormat;
  const perUnit = root.dataset.perUnit || '';
  const withUnit = (cents) => `${money(cents, fmt)}${perUnit.startsWith('/') ? '' : ' '}${perUnit}`;
  const tiers = [...root.querySelectorAll('[data-bz-tier]')];
  const modes = [...root.querySelectorAll('input[name^="bz-mode"]')];
  const rows = [...root.querySelectorAll('[data-bz-flavor]')];
  const counter = root.querySelector('[data-bz-count]');
  const target = root.querySelector('[data-bz-target]');
  const btn = root.querySelector('[data-bz-buy]');
  const btnText = root.querySelector('[data-bz-buy-text]');
  const msg = root.querySelector('[data-bz-msg]');
  const qtyOut = root.querySelector('[data-bz-qty]');
  const qtyMinus = root.querySelector('[data-bz-qty-minus]');
  const qtyPlus = root.querySelector('[data-bz-qty-plus]');
  const priceOnce = root.querySelector('[data-bz-price-once]');
  const priceSub = root.querySelector('[data-bz-price-sub]');
  const saveSub = root.querySelector('[data-bz-save-sub]');
  let packs = 1;

  const table = tiers.map((t) => {
    const i = t.querySelector('input');
    return {
      el: t,
      input: i,
      quantity: Number(i.value || 1),
      discount: Number(i.dataset.discount || 0),
      subDiscount: Number(i.dataset.subDiscount || 0),
      subAmount: Number(i.dataset.subAmount || 0) * 100,
      open: i.dataset.open === 'true',
    };
  }).sort((a, b) => a.quantity - b.quantity);

  const chosen = () => table.find((t) => t.input.checked) || table[0];
  const need = () => chosen()?.quantity || 1;
  const open = () => !!chosen()?.open;
  const subscribe = () => modes.find((m) => m.checked)?.value === 'subscription';
  const qtyOf = (r) => Number(r.querySelector('output').value);
  const count = () => rows.reduce((n, r) => n + qtyOf(r), 0);
  const setQty = (row, n) => { row.querySelector('output').value = n; };
  const unitPrice = () => Number((rows.find((r) => r.dataset.available !== 'false') || rows[0])?.dataset.price || 0);

  // Palier réellement appliqué par la boutique pour un total de paquets
  const tierFor = (total) => table.filter((t) => t.quantity <= total).pop() || null;
  // Prix d'un panier de `total` paquets valant `base` centimes
  const priceFor = (base, total, sub) => {
    const t = tierFor(total);
    if (!t) return base;
    if (!sub) return Math.round(base * (1 - t.discount / 100));
    if (t.subAmount > 0) return Math.max(0, base - t.subAmount);
    return Math.round(base * (1 - t.subDiscount / 100));
  };
  const saving = (base, total) => {
    const t = tierFor(total);
    if (t && t.subAmount > 0) return `−${money(t.subAmount, fmt).replace(',00', '')}`;
    const pct = base > 0 ? Math.round((1 - priceFor(base, total, true) / base) * 100) : 0;
    return pct > 0 ? `−${pct} %` : '';
  };

  // Répartit le palier choisi : on garde ce qui est déjà choisi, on complète par le haut de la liste
  const fill = () => {
    let left = need() - count();
    if (left < 0 && !open()) {
      for (let i = rows.length - 1; i >= 0 && left < 0; i--) {
        const q = qtyOf(rows[i]);
        const take = Math.min(q, -left); setQty(rows[i], q - take); left += take;
      }
    }
    if (!rows.some((r) => r.dataset.available !== 'false')) return;
    for (let i = 0; i < rows.length && left > 0; i++) {
      if (rows[i].dataset.available !== 'false') { setQty(rows[i], qtyOf(rows[i]) + 1); left -= 1; }
      if (left > 0 && i === rows.length - 1) i = -1;
    }
  };

  const render = () => {
    const n = count(), want = need(), sub = subscribe();
    counter.textContent = n;
    target.textContent = open() ? `${want}+` : want;
    rows.forEach((r) => {
      r.querySelector('[data-bz-minus]').disabled = qtyOf(r) <= 0;
      r.querySelector('[data-bz-plus]').disabled = (!open() && n >= want) || r.dataset.available === 'false';
    });

    // Prix des cartes paliers selon le mode choisi
    const unit = unitPrice();
    table.forEach((t) => {
      const out = t.el.querySelector('[data-bz-tier-price]');
      if (out && unit > 0) out.textContent = withUnit(Math.round(priceFor(unit * t.quantity, t.quantity, sub) / t.quantity));
    });

    // Prix au paquet dans les cartes « fréquence », pour la composition en cours
    const total = Math.max(n, want) * packs;
    const base = rows.reduce((s, r) => s + Number(r.dataset.price) * qtyOf(r), 0) * packs;
    const refBase = n >= want ? base : unit * total;
    if (priceOnce) priceOnce.textContent = withUnit(Math.round(priceFor(refBase, total, false) / total));
    if (priceSub) priceSub.textContent = withUnit(Math.round(priceFor(refBase, total, true) / total));
    if (saveSub) { const sv = saving(refBase, total); saveSub.textContent = sv; saveSub.hidden = !sv; }

    const final = priceFor(base, n * packs, sub);
    if (n < want) {
      btn.disabled = true;
      const left = want - n;
      btnText.textContent = `Choisis encore ${left} ${left > 1 ? root.dataset.unitPlural : root.dataset.unit}`;
    } else {
      btn.disabled = false;
      const small = window.matchMedia('(max-width: 989px)').matches;
      const label = small ? (root.dataset.labelMobile || root.dataset.label) : root.dataset.label;
      btnText.innerHTML = `${label} · ${final < base && !small ? `<s>${money(base, fmt)}</s> ` : ''}${money(final, fmt)}`;
    }
    if (qtyOut) qtyOut.value = packs;
    if (qtyMinus) qtyMinus.disabled = packs <= 1;
  };

  rows.forEach((r) => {
    r.querySelector('[data-bz-plus]').addEventListener('click', () => { setQty(r, qtyOf(r) + 1); render(); });
    r.querySelector('[data-bz-minus]').addEventListener('click', () => { setQty(r, Math.max(0, qtyOf(r) - 1)); render(); });
  });
  table.forEach((t) => t.input.addEventListener('change', () => { fill(); render(); }));
  modes.forEach((m) => m.addEventListener('change', render));
  qtyMinus?.addEventListener('click', () => { packs = Math.max(1, packs - 1); render(); });
  qtyPlus?.addEventListener('click', () => { packs = Math.min(10, packs + 1); render(); });
  window.matchMedia('(max-width: 989px)').addEventListener('change', render);

  // Liens du menu : ?paquets=<n> présélectionne le palier, ?abonnement présélectionne l'abonnement
  const params = new URLSearchParams(location.search);
  const wantPacks = Number(params.get('paquets'));
  const wantTier = wantPacks > 0 && table.filter((t) => t.quantity <= wantPacks).pop();
  if (wantTier) table.forEach((t) => { t.input.checked = t === wantTier; });
  if (params.has('abonnement')) { const m = modes.find((x) => x.value === 'subscription'); if (m) m.checked = true; }

  // Goût présélectionné depuis une page goût : ?gout=<handle>
  const wanted = new URLSearchParams(location.search).get('gout');
  const pre = wanted && rows.find((r) => r.dataset.handle === wanted && r.dataset.available !== 'false');
  if (pre) setQty(pre, 1);
  fill(); render();

  btn.addEventListener('click', async () => {
    msg.textContent = '';
    btn.classList.add('is-loading');
    const plan = subscribe() ? root.dataset.sellingPlan : '';
    const items = rows
      .map((r) => ({ id: Number(r.dataset.variant), quantity: qtyOf(r) * packs, plan: r.dataset.plan }))
      .filter((i) => i.quantity > 0)
      .map((i) => { const item = { id: i.id, quantity: i.quantity }; const sp = plan ? (i.plan || plan) : ''; if (sp) item.selling_plan = Number(sp); return item; });
    try { await addToCart(items, root); }
    catch (e) { msg.textContent = e.message; }
    finally { btn.classList.remove('is-loading'); }
  });
}

/* ---------- Page goût ---------- */
function initFlavor(root) {
  const tabs = [...root.querySelectorAll('[data-bz-tab]')];
  const tiles = [...root.querySelectorAll('[data-bz-tile]')];
  tabs.forEach((tab) => tab.addEventListener('click', () => {
    tabs.forEach((t) => t.classList.toggle('is-on', t === tab));
    const f = tab.dataset.bzTab;
    tiles.forEach((tile) => { tile.hidden = f !== 'all' && !(tile.dataset.groups || '').split(',').includes(f); });
  }));
  const single = root.querySelector('[data-bz-add-single]');
  single?.addEventListener('click', async () => {
    const msg = root.querySelector('[data-bz-msg]');
    msg.textContent = '';
    try { await addToCart([{ id: Number(single.dataset.variant), quantity: 1 }], root); }
    catch (e) { msg.textContent = e.message; }
  });
}

function init(scope = document) {
  scope.querySelectorAll('[data-bz-gallery]').forEach(initGallery);
  scope.querySelectorAll('[data-bz-countdown]').forEach(initCountdown);
  scope.querySelectorAll('[data-bz-delivery]').forEach(initDelivery);
  scope.querySelectorAll('[data-bz-pack]').forEach(initPack);
  scope.querySelectorAll('[data-bz-flavor-page]').forEach(initFlavor);
}
init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
